import React from 'react';
import './sec3.css'
import Titlenumb from '../components/common/titlenumber';
import pic13 from '../assets/pic13.png'
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
gsap.registerPlugin(ScrollTrigger);

const Sec3 = () => {
const [content, setcontent]= useState([]);


useEffect(() => {
gsap.fromTo('#pic-sec3',
  {scale: 0.5,opacity: 0, },
  {scale: 1, opacity: 1,duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '#pic-sec3',
      start: 'top 80%',
            toggleActions: 'play reverse play reverse',}});

const animateCount = (id, target) => {
  const el = document.getElementById(id);
  if (!el || !target) return; 

  let current = 0;
  const increment = Math.ceil(target / 60);

  const interval = setInterval(() => {
    current += increment;

    if (current >= target) {
      current = target;
      clearInterval(interval);
    }

    el.textContent = current + '+';
  }, 30);
};

const observer = new IntersectionObserver(([entry]) => {
  if (entry.isIntersecting) {
const numbers = [
  content?.[1]?.number,
  content?.[1]?.number2
];

numbers.forEach((num, index) => {
  if (num) animateCount(`num-${index}`, num);
});
  }
}, { threshold: 0.5 });

const target = document.querySelector('.row-sec3');
if (target) observer.observe(target);

  return () => observer.disconnect();
}, [content]);








useEffect(() => {
const getcontent = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setcontent(res.data);
}
getcontent();
}, []);












    return ( 
        <section className='sec3'>
            <section className='container-sec3'>
                    <article className='left-part-sec3'>
                        <h1 className='header-sec3'>{content?.[1]?.header}</h1>
                        <p className='para-sec3'>
                                    {content?.[1]?.paragraph}</p>
<article className='row-sec3'>
  <Titlenumb
    id="num-0"
    num={content?.[1]?.number}
    title={content?.[1]?.sub_title}
  />

  <Titlenumb
    id="num-1"
    num={content?.[1]?.number2}
    title={content?.[1]?.sub_title2}
  />
</article>
                    </article>

                    <div id='pic-sec3' className='pic-sec3-wrapper'>
                    <img  className='pic-sec3' src={content?.[1]?.img} alt={content?.[1]?.alt}/>
                    </div>

            </section>
        </section>
     );
}
 
export default Sec3;